angular.module('adSlot', []).
directive('adSlot', ['$rootScope', '$http', 'gplansConf', function ($rootScope, $http, gplansConf) {
  return {
    restrict: 'E',
    compile: function compile(element, attrs) {
      var type = attrs.contentCat;

      var getAds = function getAds() {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/content/',
          method: "GET",
          params: { featured: 0, category__slug: type } });

        return req;
      };


      var buildCard = function buildCard(res) {
        var ads = res.data;
        var index = Math.floor(Math.random() * ads.length),indexChosen = false;
        // this loop is to exclude duplicate ads
        // but we don't run it too many times
        if (_.isArray($rootScope.activeAds)) {
          for (var i = 0; i < 10; i++) {
            if ($rootScope.activeAds.indexOf(index) === -1) {
              indexChosen = true;
              break;
            }
            index = index < ads.length - 1 ? index + 1 : 0;
          }
        } else {
          indexChosen = true;
        }
        if (!indexChosen) return;
        if (_.isArray($rootScope.activeAds)) {
          $rootScope.activeAds.push(index);
        } else {
          $rootScope.activeAds = [index];
        }

        var ad = ads[index];
        var htmlText;

        if (ad) {
          htmlText = '' +
          '<div class="card ad-card">' +
          '<div class="card-image">' +
          '<img src="' + ad.image + '"> <span class="card-title">' + ad.title + '</span>' +
          '</div>' +
          '<div class="card-content">' +
          '<p>' + ad.short_description.substring(0, 240);+'...</p>' +
          '</div>';
          if (ad.page_html) {
            htmlText += '</div>' +
            '<div class="card-action">' +
            '<a href="/app/content/' + ad.category.slug + '/' + ad.id + '">Read more</a>' +
            '</div>';
          } else {
            htmlText += '</div>' + '<div class="card-action">' +
            '<a target="_blank" href="' + ad.link + '">Learn more</a>' +
            '</div>';

          }
        }

        element.replaceWith(htmlText);
      };

      getAds().then(buildCard);

    } };

}]);